<div class="ss-sidebar">
  <a *ngIf="hasAccess(['Admin', 'StoreAdmin'])" routerLink="/dashboard" routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: true}" class="ss-sidebar-item">
    <span class="ss-sidebar-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
        <rect x="3" y="3" width="7" height="7" rx="1"/>
        <rect x="14" y="3" width="7" height="7" rx="1"/>
        <rect x="3" y="14" width="7" height="7" rx="1"/>
        <rect x="14" y="14" width="7" height="7" rx="1"/>
      </svg>
    </span>
    <span class="ss-sidebar-label">Dashboard</span>
  </a>
  <a *ngIf="hasAccess(['Admin','StoreAdmin', 'StoreUser'])" routerLink="/batchlist" routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: true}" class="ss-sidebar-item">
    <span class="ss-sidebar-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
        <path d="M16 4H18C19.1046 4 20 4.89543 20 6V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V6C4 4.89543 4.89543 4 6 4H8"/>
        <rect x="8" y="2" width="8" height="4" rx="1"/>
        <path d="M9 12H15"/>
        <path d="M9 16H13"/>
      </svg>
    </span>
    <span class="ss-sidebar-label">Batches</span>
  </a>
  <a *ngIf="hasAccess(['StoreAdmin'])" routerLink="/user" routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: true}" class="ss-sidebar-item">
    <span class="ss-sidebar-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
        <circle cx="12" cy="8" r="4"/>
        <path d="M20 21C20 16.5817 16.4183 13 12 13C7.58172 13 4 16.5817 4 21"/>
      </svg>
    </span>
    <span class="ss-sidebar-label">Users</span>
  </a>
  <a *ngIf="hasAccess(['Admin'])" routerLink="/store" routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: true}" class="ss-sidebar-item">
    <span class="ss-sidebar-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
        <path d="M3 21H21"/>
        <path d="M5 21V7L12 3L19 7V21"/>
        <path d="M9 21V15H15V21"/>
        <path d="M9 10H10"/>
        <path d="M14 10H15"/>
      </svg>
    </span>
    <span class="ss-sidebar-label">Stores</span>
  </a>
  <a *ngIf="hasAccess(['Admin'])" routerLink="/products" routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: true}" class="ss-sidebar-item">
    <span class="ss-sidebar-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
        <path d="M9 2L4 6v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6l-5-4z"/>
        <path d="M9 10h6"/>
        <path d="M9 14h6"/>
      </svg>
    </span>
    <span class="ss-sidebar-label">Products</span>
  </a>
  <div class="ss-sidebar-version">{{ version }}</div>
</div>
